enum ImportFormats {
  mt940 = 'mt940',
}

export default ImportFormats;
